import React, { useState, useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin, Row, Button } from 'antd';
import { useForm } from 'react-hook-form';
import { forgetPassword } from '../../api/index';

const ForgetPasswordForm = (props) => {
    const { register, errors, handleSubmit, setError } = useForm();
    const [loading, setLoading] = useState(false);
    const { onChange, changeTab } = props;

    const onSubmit = (data) => {
        setLoading(true);
        forgetPassword(data)
            .then((response) => {
                setLoading(false);
                changeTab({ title: 'Forgot Password', body: response.message });
            })
            .catch((error) => {
                const keys = Object.keys(error.errors);
                keys.forEach((key) => {
                    setError(key, 'notMatch', error.errors[key]);
                });
                setError(error.errors);
                setLoading(false);
            });
    };
    useEffect(() => {}, [loading]);

    const Loading = <LoadingOutlined sytle={{ fontSize: 24 }} />;

    return (
        <form className="entry-form" onSubmit={handleSubmit(onSubmit)}>
            <div className="formFieldContainer">
                <label htmlFor="email"> Email</label>
                <div className="ant-form-item-control-input-content resetEmail">
                    <input
                        name="email"
                        placeholder="Enter Email"
                        ref={register({
                            required: 'Please enter your email',
                            pattern: {
                                value: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                message: 'Invalid email address',
                            },
                        })}
                    />
                </div>
                {errors.email && (
                    <p className="formFieldError">
                        <br />
                        {errors.email.message}
                    </p>
                )}
            </div>
            <br />
            {!loading ? (
                <input className="entry-button resetButton" type="submit" value="Reset Link" />
            ) : (
                <Row justify="center">
                    <Spin indicator={Loading} />
                </Row>
            )}
            {/* <a className="login-form-forgot" onClick={onChange}>
        Back to Sign In?
      </a> */}
            <Button className="btn-link" type="link" onClick={onChange}>
                {' '}
                Back to Sign In?
            </Button>
        </form>
    );
};

export default ForgetPasswordForm;
